import React, { useContext, useState } from "react";
import { UserContext } from "../../Context/UserContext";
import MyInput from "../../Reusable/MyInput";
import Button from "../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../Reusable/BaseURL";
import CityPageForm from "../../masterFormPages/CityPageForm";
import { StateSelect } from "../../Reusable/StateSelectTest";
import { CustomStateSelect } from "../../Reusable/CustomStateSelect";

export default function City() {
  const { darkTheme, loginData, allPermiss } = useContext(UserContext);
  const [name, setName] = useState("");

  const [selectedOption, setSelectedOption] = useState("");
  const [code, setCode] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  // create
  async function createDivision(e) {
    e.preventDefault();
    setSubmitDisable(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("state_id", selectedOption.value);
    console.log("formdata", formData);

    const res = await fetch(`${BaseURL}/cities`, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          firstPageList();
          toast.success("Success");
          setName("");
          setSelectedOption("");
          setCode("");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.name) {
          toast.error(createRes.error.message.name);
        } else if (createRes?.error?.message) {
          toast.error(createRes.error.message);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/cities?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(id, stateName, cityName) {
    setEditDisable(true);
    setChangingSelect(true);
    setSubmitAction("update");
    setName(cityName || "");
    setSelectedOption(stateName || "");
    // setCode(selectedRecord.data.state_code || "");
    setEditDisable(false);

    // TOP SCROLLING ==========
    // const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // You can use 'auto' instead of 'smooth' for instant scrolling
    });
    // };
    toast.success("Go to update form");
  }
  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    const formData = { name, state_id: selectedOption.value };
    const updRes = await fetch(`${BaseURL}/cities/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({name: divisionName}),
    })
      .then((res) => res.json())
      .then((upd) => {
        if (upd.status) {
          firstPageList();
          setGetId(0);
          toast.success("Updated");
          setName("");
          // setStateName("");
          setSelectedOption("");
          setCode("");
          setSubmitAction("submit");
          setUpdateDisable(false);
        }
        if (upd.status === false) {
          setUpdateDisable(false);
        }
        if (upd?.error?.message.name) {
          toast.error(upd.error.message.name);
        } else if (upd?.error?.message) {
          toast.error(upd.error.message);
        }
      });
  }

  function cancelUpdate() {
    setSubmitAction("submit");
    setName("");
    // setStateName("");
    setSelectedOption("");
    setCode("");
    setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false);
    setEditDisable(false);
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            City Master
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col gap-8 md:flex-row md:gap-1 lg:gap-4"
          >
            {allPermiss?.includes("master-city-create") && (
              <div className="w-full px-2 md:w-1/4">
                <form action="">
                  <div className="mb-2">
                    <label>
                      State name{" "}
                      <span className="text-red-500 font-bold">*</span>
                    </label>
                    <StateSelect
                      selectedOption={selectedOption}
                      setSelectedOption={setSelectedOption}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <MyInput
                    label="City name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full"
                    mendatory="*"
                  />
                  {/* <MyInput
                  label="State code"
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  className="w-full"
                /> */}

                  {allPermiss?.includes("master-city-create") &&
                    submitAction === "submit" && (
                      <div className="flex items-center justify-start gap-x-1">
                        <Button
                          disabled={submitDisable}
                          type="submit"
                          onClick={(e) => createDivision(e)}
                        >
                          {submitDisable ? "Wait.." : "Submit"}
                        </Button>
                        <Button type="button" onClick={() => cancelUpdate()}>
                          Clear
                        </Button>
                      </div>
                    )}
                  {allPermiss?.includes("master-city-update") &&
                    submitAction === "update" && (
                      <div className="flex items-center justify-start gap-x-1">
                        <Button
                          disabled={updateDisable}
                          type="submit"
                          onClick={(e) => updateARecord(e, getId)}
                        >
                          {updateDisable ? "Wait.." : "Update"}
                        </Button>
                        <Button onClick={() => cancelUpdate()}>Cancel</Button>
                      </div>
                    )}
                </form>
                <div className="px-3 mt-6 mb-4">
                  <div className="font-medium text-[16px] mb-2">City</div>
                  <p className={`text-gray-500`}>
                    City master is useful while we register vendor or party in
                    our application.
                  </p>
                </div>
              </div>
            )}

            {allPermiss?.includes("master-city-view") && (
              <div className="w-full px-2 md:w-[75%]">
                <CityPageForm
                  editBtn={editBtn}
                  firstPageList={firstPageList}
                  links={links}
                  firstPage={firstPage}
                  setGetId={setGetId}
                  spinner={spinner}
                  totalNo={totalNo}
                  from={from}
                  to={to}
                  editDisable={editDisable}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
